import { act, JSX } from "../../jsx-act"
import './form-field.scss'

interface FormFieldProps {
  children?: JSX.Child;
  label: string;
}

let fieldIdCounter = 0;

export default ({ label, children }: FormFieldProps) => {
  const labelId = `awsccc-field-label-${fieldIdCounter++}`;
  return (
    <div class="awsccc-u-field" role="group" aria-labelledby={labelId}>
      <span id={labelId} class="awsccc-u-field-label">{label}</span>
      <div class="awsccc-u-field-input">
        {children}
      </div>
    </div>
  )
}
